const BASE_URL = "https://magnum-fs.com";

export function siteUrl(path: string): string {
  if (!path.startsWith("/")) path = "/" + path;
  return `${BASE_URL}${path}`;
}

export function stripHtml(s: string | null | undefined): string {
  if (!s) return "";
  return s.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

export function clamp(s: string, max = 160): string {
  if (s.length <= max) return s;
  return s.slice(0, max - 1).trimEnd() + "…";
}

export function metaDescription(...candidates: Array<string | null | undefined>): string {
  for (const c of candidates) {
    const t = clamp(stripHtml(c), 160);
    if (t.length >= 40) return t;
  }
  for (const c of candidates) {
    const t = clamp(stripHtml(c), 160);
    if (t) return t;
  }
  return "";
}

export { BASE_URL };